export const walletUrl = 'wallet';
export const topUpUrl = 'top-ups';
export const cancelationReasons = 'cancellation-reasons';
